import React from 'react'
import Resx from '@/components/Resx'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ModalBody } from 'reactstrap'
import { CloseFooter } from './common/closeFooter'

export default {
  modalProps: null,
  component: (props) =>
    <React.Fragment>
      <BasicHeader {...props} />
      <ModalBody>
        <h5 className='popup-text'>{props.localizedContent || <Resx name={props.content} />}</h5>
      </ModalBody>
      <CloseFooter {...props} />
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/dialogs/alert.js